import { Col, Form, Row } from 'antd';
import { useTranslation } from 'react-i18next';

/** @deprecated - use new Tabs instead */
type CardTabsContentDeprecatedProperties = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  onChange?: (value: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  onSelect?: (value: any) => void;
  tabs: TabP[];
  title?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  value?: any;
};

type P = {
  name?: string;
  noStyle?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  onSelect?: (value: any) => void;
  tabs: TabP[];
  title?: string;
};

type TabP = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  content: any;
  id: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  key: any;
};

/** @deprecated - use new Tabs instead */
const CardTabsContentDeprecated = ({ onChange, onSelect, tabs, title, value }: CardTabsContentDeprecatedProperties) => {
  const { t } = useTranslation();
  const span = Math.floor(24 / tabs.length);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const onClick = (newValue: any) => () => {
    if (onSelect) {
      onSelect(newValue);
    }

    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <>
      {title ? (
        <Row>
          <Col className="ant-form-item-label">
            <label>{t(title)}</label>
          </Col>
        </Row>
      ) : null}
      <Row className="card-tabs-deprecated">
        {tabs.map((tab: TabP) => (
          <Col
            className={value === tab.key ? 'selected' : ''}
            id={tab.id}
            key={`card-tab_content_${tab.key}`}
            onClick={onClick(tab.key)}
            span={span}
          >
            {tab.content}
          </Col>
        ))}
      </Row>
    </>
  );
};

/** @deprecated - use new Tabs instead */
const CardTabsDeprecated = ({ name, onSelect, tabs, title }: P) => (
  // eslint-disable-next-line no-restricted-syntax -- TODO: its deprecated will be delete soon
  <Form.Item name={name}>
    <CardTabsContentDeprecated onSelect={onSelect} tabs={tabs} title={title} />
  </Form.Item>
);

export default CardTabsDeprecated;
